import {combineReducers} from 'redux';
import occupation from './occupation';
import apprenticeships from './apprenticeshipsList';

export const apprenticeshipsReducer = combineReducers({
  apprenticeshipsList: apprenticeships,
  occupationList: occupation,
});
